<template>
  <div>
    <div class="person-info">
      <div>
        <label for="">姓名</label>
        <div>{{ recordList.Interviewee }}</div>
      </div>

      <div>
        <label for="">面談日期</label>
        <div v-for="(date, index) in recordList.InterviewDateList" :key="index">
          {{ $common.dateTimeFormatter(date) }}
        </div>
      </div>
      <div v-for="score in recordList.Scores" :key="score.Name">
        <label for="">{{ score.Name }}</label>
        <div>
          <span v-if="!IsSupervisor">{{ score.OriginScore }}/</span
          >{{ score.Score }}
        </div>
      </div>
    </div>
    <template
      v-if="
        recordList.InterviewRecords && recordList.InterviewRecords.length > 0
      "
    >
      <div style="display: flex">
        <div class="interview-body" style="text-align: center">
          <div class="tab-name">
            <div class="name-inner" style="height: 55px; line-height: 50px">
              面談主管
            </div>
          </div>
          <div
            v-for="item in recordList.InterviewRecords[0]
              .InterviewRecordAppraisals"
            :key="item.Name"
            class="field"
          >
            {{ item.Name }}
          </div>

          <template v-if="recordList.ResumeType === 'IDL'">
            <div class="field">職等</div>
          </template>

          <div class="field" style="height: 80px; overflow-y: auto">
            面談說明
          </div>

          <div class="field" style="height: 80px; overflow-y: auto">
            個人備註
          </div>

          <template v-if="recordList.ResumeType === 'IDL'">
            <div class="field">是否已進行風險評估</div>
          </template>

          <div class="field">面談結果</div>
        </div>

        <div
          v-if="
            recordList.InterviewRecords &&
            recordList.InterviewRecords.length > 0
          "
          style="flex: 1; min-width: 1px"
        >
          <carousel
            style="flex: 1; min-width: 1px"
            :items="1"
            :nav="true"
            :dots="true"
          >
            <div
              v-for="record in recordList.InterviewRecords"
              class="evaluation-body"
              :key="record.InterviewId"
            >
              <div class="interview-body">
                <div class="tab-name">
                  <div class="name-inner" style="height: 55px">
                    【{{ record.InterviewTitle }}】<br />
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="
                        record.InterviewSupervisor +
                        ' (' +
                        record.InterviewUserType +
                        ')'
                      "
                      placement="right"
                    >
                      <span>
                        {{ record.InterviewSupervisor }} ({{
                          record.InterviewUserType
                        }})
                      </span>
                    </el-tooltip>
                  </div>
                </div>

                <div
                  v-for="item in record.InterviewRecordAppraisals"
                  class="field"
                  :key="item.Name"
                >
                  <el-tooltip
                    v-if="
                      item.Remark &&
                      item.Result !== '-' &&
                      item.Remark !== '未填寫'
                    "
                    class="item"
                    effect="dark"
                    :content="item.Remark"
                    placement="right"
                  >
                    <span>
                      {{ item.Result }}
                    </span>
                  </el-tooltip>
                  <span v-else>{{ item.Result }}</span>
                </div>

                <template v-if="recordList.ResumeType === 'IDL'">
                  <!-- 職等 -->
                  <div class="field">
                    {{ record.ExpectedJobLevel }}
                  </div>
                </template>

                <!-- 面談說明 -->
                <div class="field" style="height: 80px; overflow-y: auto">
                  {{ record.Remark }}
                </div>
                <!-- 個人備註 -->
                <div class="field" style="height: 80px; overflow-y: auto">
                  {{ record.PersonalRemark }}
                </div>

                <!-- 是否已進行風險評估 -->
                <div
                  v-if="recordList.ResumeType === 'IDL'"
                  class="field"
                >
                  <div v-if="record.InterviewResult === '未填寫'">未填寫</div>
                  <div v-else>已完成評估</div>
                </div>
                <!-- 面談結果 -->
                <div class="field">
                  {{ record.InterviewResult }}
                </div>
              </div>
            </div>
          </carousel>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel2";
import { mapActions } from "vuex";

export default {
  props: ["MatchId", "IsSupervisor"],

  name: "InterviewRecord",

  components: { carousel },
  data() {
    return {
      recordList: {},
    };
  },

  methods: {
    getInterviewRecordHistory() {
      if (this.IsSupervisor) {
        this.updateLoading(true);
        this.$api.approveInterview
          .getInterviewRecordForSupervisor(this.MatchId)
          .then((response) => {
            if (response.status === 200) {
              this.updateLoading(false);
              this.recordList = response.data;
            }
          });
      } else {
        this.updateLoading(true);
        this.$api.approveInterview
          .getInterviewRecordForHr(this.MatchId)
          .then((response) => {
            if (response.status === 200) {
              this.updateLoading(false);
              this.recordList = response.data;
            }
          });
      }
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  created() {
    this.getInterviewRecordHistory();
  },
};
</script>

<style lang="scss" scoped>
$color1: #636f83;

.person-info {
  display: flex;
  background-color: #636f83;
  color: #fff;
  text-align: center;
  padding: 10px;
  margin-bottom: 2px;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
  div {
    position: relative;
    flex: 1;
    label {
      border: 1px solid #fff;
      padding: 4px 10px;
      font-size: 0.8em;
      border-radius: 25px;
    }
  }
}
.interview-body {
  .tab-name {
    text-align: center;
    background-color: $color1;
    padding: 10px 0;
    .name-inner {
      display: inline-block;
      position: relative;
      padding: 3px 15px;
      letter-spacing: 2px;
      color: #fff;
    }
  }

  .field {
    padding: 6px 8px;
    text-align: center;
    height: 35px;
    &:nth-child(even) {
      background-color: #f5f5f5;
    }
    span {
      color: #000;
      padding: 3px 0;
      width: 80px;
      text-align: center;
      border-radius: 25px;
    }
  }
}
</style>
